var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detect-report-page"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("加载报告中…")]):(_vm.errorMessage)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMessage))]):_c('DetectReport',{attrs:{"detail":_vm.detail,"loading":false},on:{"refresh":_vm.loadDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }